<template>
  <div>
    <b-row class="mb-6">
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          :label="this.$t('Mail server')"
          v-if="!loading"
          label-for="mail_server"
        >
          <b-form-input
            v-model="form.mail_server"
            data-test-id="email-server"
            :class="[errorMsg.isActive ? activeClass : '']"
            @blur="setValidationInput('mail_server', $event.target.value)"
            :state="$validateState($v.form.mail_server)"
            placeholder="mailsvr.example.com"
          >
          </b-form-input>
          <p class="invalid-feedback" v-if="this.errorMsg.isActive">
            {{
              $t(
                "Please specify valid hostname or IP address for Email server."
              )
            }}
          </p>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
        <b-form-group
          :label="this.$t('Notification Interval')"
          label-for="notificationPeriod"
          v-if="!loading"
        >
          <b-form-select
            v-model="$v.form.notification_period.$model"
            data-test-id="email-settings"
            :state="$validateState($v.form.notification_period)"
            :options="notificationList"
          >
          </b-form-select>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
        <b-form-group
          :label="this.$t('From Email')"
          label-for="sender"
          v-if="!loading"
        >
          <b-form-input
            id="sender"
            data-test-id="sender"
            v-model="form.sender"
            :class="[errorMsg.isEmailActive ? activeClass : '']"
            @blur="setValidationInput('sender', $event.target.value)"
            :state="$validateState($v.form.sender)"
            :placeholder="$t('notifications@webtitan.com')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.sender.required">
              {{ $t("Must be a valid email address.") }}
            </p>
          </template>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
      </b-col>
    </b-row>
    <t-save-button
      data-test-id="email-settings-save"
      :form-model="$v.form"
      :fetching="fetching"
      @submit="onSubmit"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { minLength, maxLength, email } from "vuelidate/lib/validators";

export default {
  layout: "msp",
  data() {
    return {
      loading: true,
      fetching: false,
      activeClass: "is-invalid",
      errorMsg: {
        isEmailActive: false,
        isActive: false,
        text: "",
      },
      form: {
        notification_period: null,
        mail_server: null,
        sender: null,
      },
      dataList: [
        { text: "Every 30 minutes", value: 30, disabled: false },
        { text: "Every 15 minutes", value: 15, disabled: false },
        { text: "Every hour", value: 60, disabled: false },
        { text: "Every 2 hours", value: 120, disabled: false },
      ],
    };
  },

  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("emailSettings", ["getEmailSetting", "updateEmailSetting"]),
    ...mapActions("toast", ["displayToast"]),

    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();

      if (this.$v.form.sender.$model) {
        this.errorMsg.isEmailActive = false;
      }
      if (this.$v.form.mail_server.$model) {
        this.errorMsg.isActive = false;
      }
    },

    async onSubmit() {
      this.fetching = true;
      try {
        await this.updateEmailSetting({
          settings: this.form,
          mspId: this.mspId,
        });
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Your email settings have been updated"),
          duration: 2000,
          variant: "success",
        });
      } catch (err) {
        /* istanbul ignore next */
        if (
          err.response.data.error ===
          "Error: Please specify valid hostname or IP address for Email server"
        ) {
          this.errorMsg.isActive = true;
          this.errorMsg.text = err.response.data.error;
        }
        if (
          err.response.data.error ===
          "Error: The sender field is required when mail server is present."
        ) {
          this.errorMsg.isEmailActive = true;
        } else if (
          err.response.data.error ===
          "Error: Please specify valid hostname or IP address for Email server Error: The sender field is required when mail server is present."
        ) {
          this.errorMsg.isEmailActive = true;
          this.errorMsg.isActive = true;
        }
      } finally {
        this.fetching = false;
      }
    },
  },
  computed: {
    ...mapGetters("emailSettings", ["currentEmailSettings"]),
    ...mapGetters("authentication", ["mspId"]),

    notificationList() {
      return [
        {
          value: null,
          text: this.$t("Please select an option"),
          disabled: true,
        },
        ...this.dataList,
      ];
    },
  },

  validations: {
    form: {
      mail_server: {
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
      notification_period: {},
      sender: {
        email,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
    },
  },
  async created() {
    this.setPageTitle(this.$t("Email Settings"));
    try {
      await this.getEmailSetting({ mspId: this.mspId });
      this.form.mail_server = this.currentEmailSettings.mail_server;
      this.form.notification_period =
        this.currentEmailSettings.notification_period || 15;
      this.form.sender = this.currentEmailSettings.sender;
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "Email settings are required for sending policy notifications and forgotten password emails."
      ),
    ]);
  },
};
</script>
